import React, { useState, useEffect, useRef } from "react";
import { capitalizeWords } from './helper/CapitalizeWords'
import { FormatMoney } from '../../../Helpers/FormatNumber'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { ModalImagen } from './ModalImagen';
import { ModalUtilidadMargen } from "./ModalUtilidadMargen";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { ModalModificarTodo } from "./ModalModificarTodo";
import { ModalPromociones } from "./ModalPromociones";
import { ModalAgregarPromociones } from "./ModalAgregarPromociones";
import { ModalModificarImagen } from "./ModalModificarImagen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import SaveIcon from '@mui/icons-material/Save';
import { ModalModificarTotalPromociones } from "./ModalModificarTotalPromociones";
import AgricultureOutlinedIcon from '@mui/icons-material/AgricultureOutlined';
import TractorIcon from "../../../Styles/Usados/tractor.png"
import TrilladoraIcon from "../../../Styles/Usados/vehiculo.png"
import CabezalIcon from "../../../Styles/Usados/arado.png"
import { EnviarNotificacion } from "../../helpers/EnviarNotificacion";


export const TablaUsadosContainer = ({ datos, ObtenerListado, filtrar, setFiltrar, setKeyFiltrado, reseteoFiltro }) => {
  const containerRef = useRef(null); // Crear el ref

  const [openModal, setOpenModal] = useState(false);
  const [openModalModificarImg, setOpenModalModificarImg] = useState(false);
  const [imagenes, setImagenes] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openModalUtilidadMargen, setOpenModalUtilidadMargen] = useState(false);
  const [openModalAgregarPromo, setOpenModalAgregarPromo] = useState(false);
  const [openModalModificarPromo, setOpenModalModificarPromo] = useState(false);
  const [openModalModificarTodo, setopenModalModificarTodo] = useState(false);
  const [openModalModificarPromociones, setOpenModificarPromociones] = useState(false)



  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [nuevaData, setNuevaData] = useState([])


  const handleOpenUtilidadMargen = (rowData) => {
    setSelectedRow(rowData);
    setOpenModalUtilidadMargen(true);
  };
  const handleCloseUtilidadMargen = () => setOpenModalUtilidadMargen(false);

  const handleOpenAgregarPromo = (rowData) => {
    setSelectedRow(rowData);
    setOpenModalAgregarPromo(true);
  };

  const handleCloseAgregarPromo = () => {
    setOpenModalAgregarPromo(false);
  };

  const handleCloseModificarAllPromo = () => {
    setOpenModificarPromociones(false);
  };

  const handleOpenModificarPromo = (rowData) => {
    setSelectedRow(rowData);
    setOpenModalAgregarPromo(true);
  };

  const handleOpenPromoModal = (rowData) => {
    setSelectedRow(rowData);
    if (rowData.promocion) {
      setOpenModalModificarPromo(true); // Si ya tiene promoción, abre modificar
    } else {
      setOpenModalAgregarPromo(true); // Si no tiene promoción, abre agregar
    }
  };

  const handleOpenModificarAllPromo = (rowData) => {
    setSelectedRow(rowData);
    setOpenModificarPromociones(true); // Si no tiene promoción, abre agregar
  };

  const handleCloseModificarPromo = () => {
    setOpenModalModificarPromo(false);
  };

  const handleOpen = async (rowData) => {
    setSelectedRow(rowData);
    setLoader({ ...loader, mostrar: true });

    try {
      const result = await request.get(`ImagenesMaquinaria/BuscarImagenes?idinventario=${rowData.idinventario}`);

      if (result && result.length > 0) {
        setImagenes(result);
        setOpenModal(true);
        setLoader({ ...loader, mostrar: false });
      } else {
        setImagenes([]);
        setOpenModal(true);
        setLoader({ ...loader, mostrar: false });
      }
    } catch (error) {
      console.error(error);
      setOpenModal(true);
    }
  };



  const handleOpenModificarTodo = () => {
    setopenModalModificarTodo(true);
  };
  const handleCloseModificarTodo = () => setopenModalModificarTodo(false);

  const handleClose = () => setOpenModal(false);
  const handleCloseModificarImg = () => setOpenModalModificarImg(false);

  const onEstatus = (estatus) => {
    if (estatus === "L") {
      return "info-estatus-circulo circulo-verde"
    }
    else if (estatus === "A") {
      return "info-estatus-circulo circulo-amarillo"
    }
    else if (estatus === "V") {
      return "info-estatus-circulo circulo-rojo"
    }
  }

  const ActualizarMargen = (e, id) => {
    const nuevoMargen = e.target.value; // Obtener el nuevo valor del margen

    // Verificar si el ítem ya está en nuevaData
    setNuevaData(prevData => {
      const itemIndex = prevData.findIndex(item => item.idinventario === id); // Usamos idinventario para la comparación

      if (itemIndex !== -1) {
        // Si ya existe el ítem en nuevaData, actualizamos el objeto completo con el margen actualizado
        return prevData.map(item =>
          item.idinventario === id
            ? { ...item, margen: nuevoMargen, precio_lista: (item.costo_total / (1 - (nuevoMargen / 100))).toFixed(2), utilidad: (((item.costo_total / (1 - (nuevoMargen / 100)))) - item.costo_total).toFixed(2) } // Actualizamos el margen, pero mantenemos todo el objeto
            : item
        );
      } else {
        // Si no existe el ítem, agregamos el ítem completo desde datos con el margen modificado
        const itemToUpdate = datos.find(item => item.idinventario === id); // Obtener el ítem de datos
        return [...prevData, { ...itemToUpdate, margen: nuevoMargen, precio_lista: (itemToUpdate.costo_total / (1 - (nuevoMargen / 100))).toFixed(2), utilidad: (((itemToUpdate.costo_total / (1 - (nuevoMargen / 100)))) - itemToUpdate.costo_total).toFixed(2) }]; // Agregar el ítem completo con el margen actualizado
      }
    });
  };

  const ActualizarUtilidad = (e, id) => {
    const nuevaUtilidad = e.target.value.replace(/[^0-9.]/g, ''); // Obtener el nuevo valor del margen

    // Verificar si el ítem ya está en nuevaData
    setNuevaData(prevData => {
      const itemIndex = prevData.findIndex(item => item.idinventario === id); // Usamos idinventario para la comparación

      if (itemIndex !== -1) {
        // Si ya existe el ítem en nuevaData, actualizamos el objeto completo con el margen actualizado
        return prevData.map(item =>
          item.idinventario === id
            ? { ...item, utilidad: nuevaUtilidad, precio_lista: (item.costo_total + Number(nuevaUtilidad)).toFixed(2), margen: ((nuevaUtilidad * 100) / (item.costo_total + Number(nuevaUtilidad))).toFixed(2) } // Actualizamos el margen, pero mantenemos todo el objeto
            : item
        );
      } else {
        // Si no existe el ítem, agregamos el ítem completo desde datos con el margen modificado
        const itemToUpdate = datos.find(item => item.idinventario === id); // Obtener el ítem de datos
        return [...prevData, { ...itemToUpdate, utilidad: nuevaUtilidad, precio_lista: (itemToUpdate.costo_total + Number(nuevaUtilidad)).toFixed(2), margen: ((nuevaUtilidad * 100) / (itemToUpdate.costo_total + Number(nuevaUtilidad))).toFixed(2) }]; // Agregar el ítem completo con el margen actualizado
      }
    });
  };

  const ActualizarPrecioLista = (e, id) => {
    const nuevoPrecioLista = e.target.value.replace(/[^0-9.]/g, ''); // Obtener el nuevo valor del margen

    // Verificar si el ítem ya está en nuevaData
    setNuevaData(prevData => {
      const itemIndex = prevData.findIndex(item => item.idinventario === id); // Usamos idinventario para la comparación

      if (itemIndex !== -1) {
        // Si ya existe el ítem en nuevaData, actualizamos el objeto completo con el margen actualizado
        return prevData.map(item =>
          item.idinventario === id
            ? { ...item, utilidad: (nuevoPrecioLista - item.costo_total).toFixed(2), precio_lista: (nuevoPrecioLista), margen: (((nuevoPrecioLista - item.costo_total) * 100) / (item.costo_total + Number(nuevoPrecioLista - item.costo_total))).toFixed(2) } // Actualizamos el margen, pero mantenemos todo el objeto
            : item
        );
      }
      else {
        // Si no existe el ítem, agregamos el ítem completo desde datos con el margen modificado
        const itemToUpdate = datos.find(item => item.idinventario === id); // Obtener el ítem de datos
        return [...prevData, { ...itemToUpdate, utilidad: (nuevoPrecioLista - itemToUpdate.costo_total).toFixed(2), precio_lista: nuevoPrecioLista, margen: (((nuevoPrecioLista - itemToUpdate.costo_total) * 100) / (itemToUpdate.costo_total + Number(nuevoPrecioLista - itemToUpdate.costo_total))).toFixed(2) }]; // Agregar el ítem completo con el margen actualizado
      }
    });
  };

  const formatWithCommas = (value) => {
    if (!value) return '';
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };


  const onFiltrar = (filtro) => {
    setFiltrar(!filtrar)
    setKeyFiltrado(filtro)
  }

  const onGuardar = () => {
    // Extraer solo los campos necesarios
    const datosFiltrados = nuevaData.map(({ idinventario, margen, utilidad, precio_lista }) => {
      // Convertir precio_lista a número (asegura que se trate como un número)
      const precio = Number(precio_lista);

      const margenn = Number(margen);


      const utilidadd = Number(utilidad);


      // Si el precio es 0, undefined o null, establecer margen y utilidad en 0
      if (precio === 0 || precio === undefined || precio === null) {
        margen = 0;
        utilidad = 0;
      }

      if (margenn < 1 || margenn === undefined || margenn === null) {
        margen = 0;
      }

      if (utilidadd < 1 || utilidadd === undefined || utilidadd === null) {
        utilidad = 0;
      }

      return {
        idinventario,
        margen,
        utilidad,
        precio_lista: String(precio) // Aseguramos que precio_lista se mantenga como string si es necesario
      };
    });

    const post = { datosActualizados: datosFiltrados };

    console.log(post);

    setLoader({ ...loader, mostrar: true });

    request
      .post("Inventario/ActualizarTodosPrecio", post)
      .then(() => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Éxito", "Datos actualizados correctamente", "success");
        setNuevaData([]);
        ObtenerListado();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Error", JSON.stringify(error), "error");
      });
  };

  const onCambioEstado = async (idinventario, estado) => {
    const nuevoEstado = estado === 'A' ? 'Listo para vender' : 'Acondicionando'
    const mensajeEstado = estado === 'A'
      ? "El estatus cambiará a 'Listo para vender'"
      : "El estatus cambiará a 'Acondicionando'";

    const preguntaEstado = estado === 'A' ? "¿Esta seguro que quiere cambiar el estatus a 'Listo para vender'?" : "¿Esta seguro que quiere cambiar el estatus a 'Acondicionando'?"
    const confirmacion = await Swal.fire({
      title: preguntaEstado,
      text: mensajeEstado,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, Cambiar',
      cancelButtonText: 'Cancelar',
    });

    if (!confirmacion.isConfirmed) return;
    try {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`Inventario/CambioEstado?idinventario=${idinventario}`)
        .then(() => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Éxito", `El estatus ha sido cambiado a '${nuevoEstado}'`, "success");
          ObtenerListado();
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Error", JSON.stringify(error), "error");
        });
    } catch (error) {
      Swal.fire("Error", "No se pudo realizar el cambio de estatus", "error");
      return;
    }
  };

  const totalPrecio = datos.reduce((sum, item) => sum + item.precio, 0);
  const totalCosto = datos.reduce((sum, item) => sum + item.costo, 0);
  const totalOt = datos.reduce((sum, item) => sum + item.ot, 0);
  const totalCostoTotal = datos.reduce((sum, item) => sum + item.costo_total, 0);
  const totalUtilidad = datos.reduce((sum, item) => sum + (item.utilidad || 0), 0);
  const totalPrecioLista = datos.reduce((sum, item) => sum + (item.precio_lista || 0), 0);
  const margenTotal = totalCosto !== 0 ? (totalUtilidad / totalCosto) * 100 : 0;

  const formatMargen = (margen) => {
    return margen % 1 === 0 ? `${margen}.00` : margen.toFixed(2);
  };

  const onActualizar = () => {
    const datosActualizar = nuevaData.length > 0 ? nuevaData : datos;
    const tieneProductoSinPromocion = datosActualizar.some(producto => !producto.promocion);


    setLoader({ ...loader, mostrar: true });

    if (tieneProductoSinPromocion) {
      setLoader({ ...loader, mostrar: false });
      Swal.fire("Error", "Hay un producto sin promoción en el listado que intenta actualizar.", "error");
    }
    else {
      request
        .post("Inventario/ActualizarListadoPrecio", datosActualizar)
        .then(() => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Éxito", "Datos actualizados correctamente", "success");
          setNuevaData([]);
          ObtenerListado();
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Error", JSON.stringify(error), "error");
        });
    }
  };

  // Función para obtener el margen
  const getMargen = (idInventario, nuevaData, datos) => {
    const item = nuevaData.find(item => item.idinventario === idInventario);
    return item?.margen === "" ? "" : item?.margen ?? datos.margen.toFixed(2);
  };


  const familiasOrdenadas = ["Tractores", "Trilladoras", "Cabezales", "Implementos"];

  const clasificarFamilia = (modelo) => {

    if (
      modelo.toLowerCase().includes("tractor") ||
      modelo.toLowerCase().includes("tr-") ||
      modelo.toLowerCase().includes("tr ")
    ) {
      return "Tractores";
    }
    if (modelo.toLowerCase().includes("trilladora")) return "Trilladoras";
    if (modelo.toLowerCase().includes("cabezal")) return "Cabezales";
    return "Implementos";
  };

  const datosAgrupados = datos.reduce((acc, dato) => {
    const familia = clasificarFamilia(dato.modelo_descripcion);
    if (!acc[familia]) acc[familia] = [];
    acc[familia].push(dato);
    return acc;
  }, {});

  // Ordenamos los datos dentro de cada familia primero por 'estatus' (L antes que A), luego por 'sucursal' y finalmente por 'hp'
  Object.keys(datosAgrupados).forEach(familia => {
    datosAgrupados[familia].sort((a, b) => {
      // Primero, ordenar por 'estatus' (L antes que A)
      if (a.estatus === "L" && b.estatus !== "L") return -1; // 'L' antes que 'A'
      if (a.estatus !== "L" && b.estatus === "L") return 1;  // 'A' después que 'L'

      // Si ambos tienen el mismo 'estatus', ordenar por 'sucursal'
      if (a.estatus === b.estatus) {
        if (a.sucursal !== b.sucursal) {
          return a.sucursal - b.sucursal; // Orden ascendente por 'sucursal'
        }

        // Si ambos tienen el mismo 'estatus' y 'sucursal', ordenar por 'hp'
        return a.hp - b.hp; // Orden ascendente por 'hp'
      }

      return 0;
    });
  });

  const [stickyHeaders, setStickyHeaders] = useState({});

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const rows = containerRef.current.querySelectorAll(".familia-header");
      let currentHeader = null;

      rows.forEach(row => {
        const rect = row.getBoundingClientRect();
        if (rect.top <= 60) { // Ajusta la altura según sea necesario
          currentHeader = row.innerText;
        }
      });

      setStickyHeaders(prevState => ({
        ...prevState,
        current: currentHeader,
      }));
    };

    // Esperamos a que el `ref` tenga un valor antes de agregar el evento
    if (containerRef.current) {
      containerRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [containerRef.current]);

  const obtenerIconoFamilia = (familia) => {
    switch (familia) {
      case 'Tractores':
        // return <AgricultureOutlinedIcon />;
        return <img src={TractorIcon} alt="Tractor" className="img-trilladora" />;
      case 'Trilladoras':
        return <img src={TrilladoraIcon} alt="Trilladora" className="img-trilladora" />;
      case 'Cabezal':
        return <img src={CabezalIcon} alt="Cabezal" className="img-trilladora" />;
      default:
        return <img src={CabezalIcon} alt="Cabezal" className="img-trilladora" />;
    }
  };

  return (
    <div className="listado-precios-container-inv">
      <LoaderScreen loader={loader} />

      <div className="listado-precios-container-table scroll">

        <table cellSpacing={0} cellPadding={0}>
          <thead>
            <tr>
              <th className='celda-circulo celda-fija-numero'>

              </th>
              <th className='celda-circulo celda-fija'>

              </th>
              <th className="celda-fija-2">
                <div>SUCURSAL</div>
              </th>
              <th className="celda-fija-3">
                <div>MODELO</div>
              </th>
              <th className="celda-fija-4">
                <div>N. E.</div>
              </th>
              <th>
                <div>MARCA</div>
              </th>
              <th>
                <div>AÑO</div>
              </th>
              <th>
                <div>HP</div>
              </th>
              <th>
                <div>SERIE</div>
              </th>
              <th>
                <div>HORAS</div>
              </th>
              <th>
                <div>RECEPCION</div>
              </th>
              <th>
                <div>COSTO</div>
              </th>
              <th>
                <div>OT</div>
              </th>
              <th>
                <div>COSTO TOTAL</div>
              </th>
              <th>
                <div>UTILIDAD</div>
              </th>
              <th>
                <div>MARGEN</div>
              </th>
              <th>
                <div>PRECIO DE LISTA</div>
              </th>
              <th>
                <div>PROMOCION</div>
              </th>
              <th>
                <div>
                  IMAGENES
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {familiasOrdenadas.map(familia => (
              datosAgrupados[familia] ? (
                <React.Fragment key={familia}>
                  <tr className="familia-header sticky-familia">
                    <td colSpan={5} className="celda-fija-familia">
                      <div className="celda-titulo-familia">
                        {obtenerIconoFamilia(familia)}
                        {familia.toUpperCase()}
                      </div>
                    </td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                  </tr>
                  {datosAgrupados[familia].map((datos, index) => (
                    <tr key={datos.id || index}>
                      <td className="celda-circulo celda-fija-numero">{index + 1}</td>
                      <td className="celda-circulo celda-fija">
                        <div className={onEstatus(datos.estatus)} onClick={() => onCambioEstado(datos.idinventario, datos.estatus)}></div>
                      </td>
                      <td className="celda-sucursal ta-center celda-fija-2">{datos.nombre_sucursal}</td>
                      <td className="celda-modelo celda-fija-3">{datos.modelo_descripcion}</td>
                      <td className='celda-chica celda-fija-4'>{datos.ne}</td>
                      <td className="celda-marca ta-center">{datos.marca = 'JD' ? 'JOHN DEERE' : datos.marca}</td>
                      <td className='celda-chica'>{datos.ejercicio}</td>
                      <td className='celda-chica'>{datos.hp}</td>
                      <td className="celda-serie">{datos.serie}</td>
                      <td className='celda-chica'>{datos.horas}</td>
                      <td className='celda-chica'>{datos.fecha_recepcion}</td>
                      <td className='celda-importe'>{datos.costo === 0 ? '-' : FormatMoney(datos.costo, 0)}</td>
                      <td className='celda-importe'>{datos.ot === 0 ? '-' : FormatMoney(datos.ot, 0)}</td>
                      <td className='celda-importe'>{datos.costo_total === 0 ? '-' : FormatMoney(datos.costo_total, 0)}</td>
                      <td className={'celda-importe'}
                        style={{ cursor: "pointer" }}>
                        <input
                          type="text"
                          className={(datos.utilidad < 0 || nuevaData.find(item => item.idinventario === datos.idinventario)?.utilidad < 0 ? 'red' : '')}
                          value={
                            nuevaData.find(item => item.idinventario === datos.idinventario)?.utilidad === ""
                              ? ""
                              : formatWithCommas(
                                Number(nuevaData.find(item => item.idinventario === datos.idinventario)?.utilidad || datos.utilidad || 0).toString()
                              )
                          }
                          onChange={(e) => ActualizarUtilidad(e, datos.idinventario)}
                          placeholder="$" // Indicando que es un porcentaje
                        />
                      </td>


                      <td className='celda-importe' style={{ cursor: "pointer" }}>
                        <input
                          // className="input-margen"
                          className={"input-margen " + (nuevaData.find(item => item.idinventario === datos.idinventario)?.utilidad < 0 || datos.utilidad < 0 ? 'red' : '')}
                          type="number"
                          value={getMargen(datos.idinventario, nuevaData, datos)}
                          onChange={(e) => ActualizarMargen(e, datos.idinventario)}
                          placeholder="%"
                        />
                        %
                      </td>


                      <td className='celda-importe' style={{ cursor: "pointer" }}>
                        <input
                          type="text"
                          value={
                            nuevaData.find(item => item.idinventario === datos.idinventario)?.precio_lista === ""
                              ? ""
                              : formatWithCommas(Number(nuevaData.find(item => item.idinventario === datos.idinventario)?.precio_lista || datos.precio_lista).toString())
                          }
                          onChange={(e) => ActualizarPrecioLista(e, datos.idinventario)}
                          placeholder=""
                        />
                      </td>

                      {/* <td className='celda-importe' style={{ cursor: "pointer" }}>
                        <input
                          type="text"
                          value={
                            nuevaData.find(item => item.idinventario === datos.idinventario)?.precio_lista === ""
                              ? ""
                              : formatWithCommas(nuevaData.find(item => item.idinventario === datos.idinventario)?.precio_lista || datos.precio_lista)
                          }
                          onChange={(e) => ActualizarPrecioLista(e, datos.idinventario)}
                          placeholder=""
                        />
                      </td> */}


                      <td className="celda-promocion">
                        <div className="celda-promocion-container" style={{ display: "flex", alignItems: "center" }}>
                          <div
                            className="promocion-button"
                            onClick={() => handleOpenPromoModal(datos)}
                            style={{ cursor: "pointer" }}
                          >
                            <LocalOfferIcon />
                            {/* Promociones */}
                          </div>

                          <div>
                            {datos.promocion ? datos.promocion.toUpperCase() : ''}
                            <br />
                            {datos.vigencia ? datos.vigencia : ''}
                          </div>
                        </div>
                      </td>

                      <td className='celda-button'>
                        <div className="imagenes-button" onClick={() => handleOpen(datos)} style={{ cursor: "pointer" }}>
                          <AddPhotoAlternateIcon />
                          Imágenes
                        </div>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={4} className="celda-fija"></td>
                    <td className="celda-fija-4 celda-total-grupo">Total:</td>
                    <td colSpan={6}></td>
                    <td className="celda-total-grupo-importe">{FormatMoney(datosAgrupados[familia].reduce((total, datos) => total + datos.costo, 0))}</td>
                    <td className="celda-total-grupo-importe">{FormatMoney(datosAgrupados[familia].reduce((total, datos) => total + datos.ot, 0))}</td>
                    <td className="celda-total-grupo-importe">{FormatMoney(datosAgrupados[familia].reduce((total, datos) => total + datos.costo_total, 0))}</td>
                    <td className="celda-total-grupo-importe">{FormatMoney(datosAgrupados[familia].reduce((total, datos) => total + datos.utilidad, 0))}</td>
                    <td className="celda-total-grupo-importe"> {(
                      datosAgrupados[familia].reduce((total, datos) => total + datos.utilidad, 0) /
                      datosAgrupados[familia].reduce((total, datos) => total + datos.precio_lista, 0) * 100
                    ).toFixed(2)} %</td>
                    <td className="celda-total-grupo-importe">{FormatMoney(datosAgrupados[familia].reduce((total, datos) => total + datos.precio_lista, 0))}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </React.Fragment>
              ) : null
            ))}
            <tr className="fila-totales">
              <td colSpan={4} className="celda-fija"></td>
              <td className="celda-fija-4 celda-total-grupo">Totales:</td>
              <td colSpan={6}></td>

              <td className='celda-importe'>{FormatMoney(totalCosto, 0)}</td>
              <td className='celda-importe'>{FormatMoney(totalOt, 0)}</td>
              <td className='celda-importe'>{FormatMoney(totalCostoTotal, 0)}</td>
              <td className='celda-importe'>{FormatMoney(totalUtilidad, 0)}</td>
              <td className='celda-importe'>{FormatMoney(totalUtilidad / totalPrecioLista * 100)}%</td>
              <td className='celda-importe'>{FormatMoney(totalPrecioLista, 0)}</td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>



      <div className="listado-precios-footer-container">
        <div className="listado-precios-info-container">
          <div className="info-estatus">

            <div className="info-estatus-container-complete green" onClick={() => onFiltrar("L")}>
              <div className="info-estatus-circulo circulo-verde"></div>
              Listo para la venta
            </div>

            <div className="info-estatus-container-complete green" onClick={() => onFiltrar("A")}>
              <div className="info-estatus-circulo circulo-amarillo"></div>
              Acondicionando
            </div>

            <div className="info-estatus-container-complete green" onClick={() => onFiltrar("T")}>
              <div className="info-estatus-circulo circulo-dividido"></div>
              Todos
            </div>

          </div>
        </div>

        <div className="listado-precio-buttons-container">
          {nuevaData.length > 0 && (
            <div>
              <button className="listado-precios-button-guardar"
                onClick={() => onGuardar()}
              >
                <SaveIcon />
                Aplicar cambios
              </button>
            </div>
          )}

          <div>
            <button className="listado-precios-button-actualizar"
              onClick={() => onActualizar()}
            >
              <RestartAltIcon />
              Actualizar Listado
            </button>
          </div>

          <div>
            <button className="listado-precios-button-modificar-todo"
              onClick={() => handleOpenModificarTodo()}
            >
              <RestartAltIcon />
              Utilidad/Margen
            </button>
          </div>
          <div>
            <button className="listado-precios-button-modificar-promociones"
              onClick={() => handleOpenModificarAllPromo(datos)}
            >
              <LocalOfferIcon />
              Promociones
            </button>
          </div>
        </div>

      </div>
      <ModalImagen open={openModal} handleClose={handleClose} datos={selectedRow} imagenesBD={imagenes} />

      <ModalModificarImagen open={openModalModificarImg} handleClose={handleCloseModificarImg} datos={selectedRow} imagenesBD={imagenes} />
      <ModalUtilidadMargen
        open={openModalUtilidadMargen}
        handleClose={handleCloseUtilidadMargen}
        datos={selectedRow}
        ObtenerListado={ObtenerListado}
      />
      <ModalPromociones
        open={openModalModificarPromo}
        handleClose={handleCloseModificarPromo}
        datos={selectedRow}
        ObtenerListado={ObtenerListado}
      />
      <ModalAgregarPromociones
        open={openModalAgregarPromo}
        handleClose={handleCloseAgregarPromo}
        datos={selectedRow}
        ObtenerListado={ObtenerListado}
      />
      <ModalModificarTodo
        open={openModalModificarTodo}
        reseteoFiltro={reseteoFiltro}
        handleClose={handleCloseModificarTodo}
        ObtenerListado={ObtenerListado}
        datos={datos}
      />

      <ModalModificarTotalPromociones
        open={openModalModificarPromociones}
        reseteoFiltro={reseteoFiltro}
        handleClose={handleCloseModificarAllPromo}
        datos={datos}
        ObtenerListado={ObtenerListado}
      />
    </div>
  )
}
